export enum E_SEW_WS_PARAGRAPH_SIZE {
    S = 1,
    M,
    L,
}
